import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowRight, Award, Zap, Clock } from 'lucide-react';
import { useContactForm } from '../context/ContactFormContext';

const CTA = () => {
  const { t } = useTranslation();
  const { open } = useContactForm();

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-crypto-black via-crypto-dark to-crypto-black">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-crypto-red/10 via-transparent to-transparent" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-crypto-red/5 rounded-full blur-[200px]" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Decorative elements */}
          <div className="flex justify-center gap-4 mb-8">
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-12 h-12 bg-crypto-red/10 rounded-xl flex items-center justify-center"
            >
              <Award className="w-6 h-6 text-crypto-red" />
            </motion.div>
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 0.3 }}
              className="w-12 h-12 bg-crypto-accent/10 rounded-xl flex items-center justify-center"
            >
              <Zap className="w-6 h-6 text-crypto-accent" />
            </motion.div>
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 0.6 }}
              className="w-12 h-12 bg-crypto-success/10 rounded-xl flex items-center justify-center"
            >
              <Clock className="w-6 h-6 text-crypto-success" />
            </motion.div>
          </div>

          {/* Title */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            {t('cta.title')}
          </h2>
          
          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>

          {/* CTA Button */}
          <motion.button
            onClick={() => open()}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-crypto-red to-crypto-gradient-end text-white font-bold rounded-2xl text-xl hover:shadow-2xl hover:shadow-crypto-red/30 transition-all duration-300"
          >
            {t('cta.button')}
            <ArrowRight className="w-6 h-6" />
          </motion.button>
        </motion.div>
      </div>

    </section>
  );
};

export default CTA;
